export enum SocialUrls {
  EXPN_YOUTUBE = 'https://www.youtube.com/@ExplearningCo',
  EXPN_INSTAGRAM = 'https://www.instagram.com/explearning',
  EXPN_TWITTER = 'https://twitter.com/ExplearningCo',
  EXPN_FACEBOOK = 'https://www.facebook.com/myexplearning',
  EXPN_LINKEDIN = 'https://www.linkedin.com/company/explearning',
  MDLS_YOUTUBE = 'https://www.youtube.com/@MaryDaphne',
  MDLS_INSTAGRAM = 'https://www.instagram.com/MaryDaphneCo',
  MDLS_TWITTER = 'https://twitter.com/MaryDaphne',
  MDLS_FACEBOOK = 'https://www.facebook.com/MaryDaphneCo',
  MDLS_LINKEDIN = 'https://www.linkedin.com/company/mary-daphne',
  SYW_YOUTUBE = 'https://www.youtube.com/@stakeyourwealth',
  SYW_INSTAGRAM = 'https://www.instagram.com/StakeYourWealth',
  SYW_TWITTER = 'https://twitter.com/StakeYourWealth',
  SYW_FACEBOOK = 'https://www.facebook.com/StakeYourWealth',
  SYW_LINKEDIN = 'https://www.linkedin.com/company/stake-your-wealth',
  ADVE_YOUTUBE = 'https://www.youtube.com/@AdvancedEnglish',
  ADVE_INSTAGRAM = 'https://www.instagram.com/AdvancedEnglishCo',
  ADVE_TWITTER = 'https://twitter.com/Advanc3dEnglish',
  ADVE_FACEBOOK = 'https://www.facebook.com/Advanced-English-105939268048971',
  ADVE_LINKEDIN = 'https://www.linkedin.com/company/advanced-english-co',
}

export enum YouTubeChannelIds {
  EXPN = 'UCMnAKOzuvMSuBSoPUL3dXlw',
  MDLS = 'UCzXSvUpoRpBz3X2Cmh7JTxA',
  SYW = 'UCXFp9ycwsUTh7BTzrUNDcow',
  ADVE = 'UCTVVFq9b_esfd94wl_BO2ow',
}

export enum SocialUrlPrefixes {
  YOUTUBE_CHANNEL = 'https://www.youtube.com/channel',
  YOUTUBE_VIDEO = 'https://youtu.be',
  YOUTUBE_VIDEO_LONG = 'https://www.youtube.com',
  SPOTIFY_PODCAST = 'https://podcasters.spotify.com/pod/show'
}